import BooleanFormatter from './standard/BooleanFormatter.js';
import NumberFormatter from './standard/NumberFormatter.js';
import DateFormatter from './dates/DateFormatter.js';
import DateTimeFormatter from './dates/DateTimeFormatter.js';
import TimeFormatter from './dates/TimeFormatter.js';

var Format = function Format(_ref) {
  var value = _ref.value,
      format = _ref.format;
  return format(value);
};
/** Formats a value as a boolean */


Format.Boolean = BooleanFormatter;
/** Formats a value as a number */

Format.Number = NumberFormatter;
/** Formats a value as a date */

Format.Date = DateFormatter;
/** Formats a value as a date and time */

Format.DateTime = DateTimeFormatter;
/** Formats a value as a time */

Format.Time = TimeFormatter;
var Format$1 = Format;

export { Format$1 as default };
